<template>
  <div class="wrapper my-8 mx-8">
    <p>
      <span style="color: rgb(0, 170, 221)"
        >Dashboard / Insurance Companies /</span
      >
      {{ selectedCompany.registeredName }}
    </p>
    <div class="cell mt-10">
      <div class="d-flex">
        <div
          style="position: relative"
          class="d-flex flex-column align-center pt-12 px-12"
        >
          <img src="/img/ta.svg" alt="Ta image" />
          <h3 class="mt-8">{{ selectedCompany.registeredName }}</h3>
          <div
            class="pending mt-3"
            v-if="selectedCompany.BORevisedStatus === 'pending'"
          >
            <p class="px-4 white--text text-center">PENDING APPROVAL</p>
          </div>
          <div
            class="green mt-3"
            v-else-if="
              selectedCompany.BORevisedStatus == 'accepted' &&
              !(
                selectedCompany.taAdminUserProfile &&
                selectedCompany.taAdminUserProfile.isBlocked
              )
            "
          >
            <p class="px-4 white--text">ACTIVE</p>
          </div>
          <div
            class="blocked mt-3"
            v-else-if="
              selectedCompany.taAdminUserProfile &&
              selectedCompany.taAdminUserProfile.isBlocked
            "
          >
            <p class="px-3 white--text">Blocked</p>
          </div>
          <div
            class="blocked mt-3"
            v-else-if="selectedCompany.BORevisedStatus == 'rejected'"
          >
            <p class="px-3 white--text">Rejected</p>
          </div>

          <div
            class="d-flex flex-column align-center justify-center my-12"
            v-if="selectedCompany.BORevisedStatus == 'accepted'"
          >
            <p class="font-weight-bold">This month</p>
            <h1 class="font-weight-bold">0$</h1>
            <p>Outstanding Amount</p>
            <div class="d-flex align-center justify-center mt-4">
              <div class="d-flex flex-column justify-center align-center">
                <h3 class="font-weight-bold">1.321$</h3>
                <p>Total Amount</p>
              </div>
              <div
                class="mx-5"
                style="
                  height: 40px;
                  width: 1px;
                  background-color: rgb(144, 144, 144);
                "
              ></div>
              <div class="d-flex flex-column justify-center align-center">
                <h3 class="font-weight-bold">1.321$</h3>
                <p>Amount Paid</p>
              </div>
            </div>

            <div class="d-flex flex-column mt-8">
              <div class="d-flex">
                <p class="font-weight-bold mr-3">560</p>
                <p>total incidents closed</p>
              </div>
              <div class="d-flex">
                <p class="font-weight-bold mr-3">56</p>
                <p>total incidents pending</p>
              </div>
            </div>
          </div>

          <p class="my-6 pb-5 text-center">
            Registration Request
            <span
              v-if="
                selectedCompany.taAdminUserProfile &&
                selectedCompany.taAdminUserProfile.createdAt
              "
              class="dark"
              >{{
                convertDateHere(selectedCompany.taAdminUserProfile.createdAt)
              }}</span
            >
          </p>
          <div
            class="mt-12 d-flex flex-column align-center justify-center"
            v-if="selectedCompany.BORevisedStatus == 'rejected'"
          >
            <p>Changed your mind?</p>
            <div
              class="d-flex align-center justify-center mt-2"
              style="cursor: pointer"
              @click="approveDialog = true"
            >
              <v-icon left color="rgb(130,215,74)"
                >mdi-check-circle-outline</v-icon
              >
              <p class="black--text">Accept Company</p>
            </div>
          </div>

          <div
            class="
              pendingButtons
              d-flex
              flex-column flex-md-row
              align-center
              justify-center
              mt-12
            "
            v-if="selectedCompany.BORevisedStatus == 'pending'"
          >
            <v-btn
              depressed
              rounded
              class="text-capitalize white--text mb-sm-2 mb-md-0"
              color="rgb(255,0,0)"
              @click="rejectDialog = true"
              >Reject</v-btn
            >
            <v-btn
              depressed
              rounded
              class="text-capitalize white--text ml-md-2"
              color="rgb(113,210,48)"
              @click="approveDialog = true"
              >Approve</v-btn
            >
          </div>

          <div
            style="position: absolute; bottom: 0"
            v-if="
              !(
                selectedCompany.taAdminUserProfile &&
                selectedCompany.taAdminUserProfile.isBlocked
              ) &&
              selectedCompany.BORevisedStatus !== 'rejected' &&
              selectedCompany.BORevisedStatus !== 'pending'
            "
          >
            <v-btn
              class="text-capitalize"
              color="rgb(222,36,65)"
              text
              @click="blockDialog = true"
            >
              <img
                class="mr-2"
                style="height: 20px; width: auto"
                src="/img/ban.svg"
                alt
              />
              Block Company
            </v-btn>
          </div>

          <div
            style="position: absolute; bottom: 0"
            v-else-if="
              selectedCompany.taAdminUserProfile &&
              selectedCompany.taAdminUserProfile.isBlocked
            "
          >
            <v-btn class="text-capitalize" text @click="unblockDialog = true">
              <img
                src="/img/approve.svg"
                style="height: 20px; width: auto"
                class="mr-2"
                alt
              />
              <p class="black--text">Unblock Company</p>
            </v-btn>
          </div>
        </div>
        <hr class="mr-10 my-10 rgb(242,242,242)" style="align-self: strech" />
        <div style="flex: 1">
          <v-tabs color="rgb(0,170,221)" v-model="active">
            <v-tab class="black--text">General Info</v-tab>
            <v-tab
              class="black--text"
              v-if="selectedCompany.BORevisedStatus == 'accepted'"
              >Company Structure</v-tab
            >
            <v-tab
              class="black--text"
              v-if="selectedCompany.BORevisedStatus == 'accepted'"
              >Activity</v-tab
            >
            <v-tab
              class="black--text"
              v-if="selectedCompany.BORevisedStatus == 'accepted'"
              >History</v-tab
            >
            <v-tab-item>
              <div class="d-flex flex-column mt-7">
                <p class="black--text">Company General Info</p>
                <v-row>
                  <!-- <v-col cols="12">
                    <v-row>
                      <v-col cols="6"></v-col>
                      <v-col cols="6"></v-col>
                    </v-row>
                  </v-col>-->
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col xs="6" md="5" lg="3">
                        <p>VAT/TAX Registration Number:</p>
                      </v-col>
                      <v-col xs="6" md="7" lg="9">
                        <p class="dark pl-3">{{ selectedCompany.taxId }}</p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col xs="6" md="5" lg="3">
                        <p>DUNS Number:</p>
                      </v-col>
                      <v-col xs="6" md="7" lg="9">
                        <p class="dark pl-3">{{ selectedCompany.DunsNo }}</p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col xs="6" md="5" lg="3">
                        <p>Country:</p>
                      </v-col>
                      <v-col xs="6" md="7" lg="9">
                        <p
                          class="dark pl-3"
                          v-if="
                            selectedCompany.taAdminUserProfile &&
                            selectedCompany.taAdminUserProfile.homeCountryName
                          "
                        >
                          {{
                            selectedCompany.taAdminUserProfile.homeCountryName
                          }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col xs="6" md="5" lg="3">
                        <p>Address:</p>
                      </v-col>
                      <v-col xs="6" md="7" lg="9">
                        <p class="dark pl-3">
                          {{ selectedCompany.addressprofile.address }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col xs="6" md="5" lg="3">
                        <p>City:</p>
                      </v-col>
                      <v-col xs="6" md="7" lg="9">
                        <p class="dark pl-3">
                          {{ selectedCompany.addressprofile.city }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col xs="6" md="5" lg="3">
                        <p>Post code:</p>
                      </v-col>
                      <v-col xs="6" md="7" lg="9">
                        <p class="dark pl-3">
                          {{ selectedCompany.addressprofile.zipcode }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col xs="6" md="5" lg="3">
                        <p>Phone Number:</p>
                      </v-col>
                      <v-col xs="6" md="7" lg="9">
                        <p class="dark pl-3">{{ selectedCompany.phoneNo }}</p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <p class="black--text">Contact Person</p>

                <v-row>
                  <v-col cols="12">
                    <v-row no-gutters="">
                      <v-col xs="6" md="5" lg="3">
                        <p>First Name:</p>
                      </v-col>
                      <v-col xs="6" md="5" lg="3">
                        <p
                          class="dark pl-3"
                          v-if="
                            selectedCompany.taAdminUserProfile &&
                            selectedCompany.taAdminUserProfile.firstName
                          "
                        >
                          {{ selectedCompany.taAdminUserProfile.firstName }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters="">
                      <v-col xs="6" md="5" lg="3">
                        <p>Last Name:</p>
                      </v-col>
                      <v-col xs="6" md="5" lg="3">
                        <p
                          class="dark pl-3"
                          v-if="
                            selectedCompany.taAdminUserProfile &&
                            selectedCompany.taAdminUserProfile.lastName
                          "
                        >
                          {{ selectedCompany.taAdminUserProfile.lastName }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters="">
                      <v-col xs="6" md="5" lg="3">
                        <p>Email:</p>
                      </v-col>
                      <v-col xs="6" md="5" lg="3">
                        <p
                          class="dark pl-3"
                          v-if="
                            selectedCompany.taAdminUserProfile &&
                            selectedCompany.taAdminUserProfile.email
                          "
                        >
                          {{ selectedCompany.taAdminUserProfile.email }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row no-gutters="">
                      <v-col xs="6" md="5" lg="3">
                        <p>Mobile Number:</p>
                      </v-col>
                      <v-col xs="6" md="5" lg="3">
                        <p
                          class="dark pl-3"
                          v-if="
                            selectedCompany.taAdminUserProfile &&
                            selectedCompany.taAdminUserProfile.mobile
                          "
                        >
                          {{ selectedCompany.taAdminUserProfile.mobile }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <div v-if="selectedCompany.BORevisedStatus === 'accepted'">
                  <p class="black--text">Opening hours</p>
                  <v-row>
                    <v-col xs="6" md="5" lg="3">
                      <p>Working hours / days</p>
                    </v-col>
                    <v-col xs="6" md="7" lg="9">
                      <div
                        v-for="(
                          workDay, index
                        ) in selectedCompany.taWorkingHours"
                        :key="index"
                      >
                        <p class="dark">
                          {{ convertDay(workDay.weekday) }}
                          {{ convertHour(workDay.start) }} -
                          {{ convertHour(workDay.end) }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>

                  <p class="black--text">Billing Profile</p>
                  <v-row>
                    <v-col cols="12">
                      <v-row no-gutters>
                        <v-col cols="6" md="5" lg="3">
                          <p>Bank name:</p>
                        </v-col>
                        <v-col cols="6" md="5" lg="3">
                          <p class="dark">
                            {{ selectedCompany.billingProfile.accountBankName }}
                          </p>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="6" md="5" lg="3">
                          <p>Bank full address:</p>
                        </v-col>
                        <v-col cols="6" md="5" lg="3">
                          <p class="dark">
                            {{
                              selectedCompany.billingProfile.accountBankAddress
                                .address
                            }},
                            {{
                              selectedCompany.billingProfile.accountBankAddress
                                .city
                            }}
                          </p>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="6" md="5" lg="3">
                          <p>Country:</p>
                        </v-col>
                        <v-col cols="6" md="5" lg="3">
                          <p class="dark">
                            {{
                              selectedCompany.billingProfile.accountBankAddress
                                .CountryName
                            }}
                          </p>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="6" md="5" lg="3">
                          <p>Postal code:</p>
                        </v-col>
                        <v-col cols="6" md="5" lg="3">
                          <p class="dark">
                            {{
                              selectedCompany.billingProfile.accountBankAddress
                                .zipcode
                            }}
                          </p>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="6" md="5" lg="3">
                          <p>Account number:</p>
                        </v-col>
                        <v-col cols="6" md="5" lg="3">
                          <p class="dark">
                            {{ selectedCompany.billingProfile.accountNo }}
                          </p>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="6" md="5" lg="3">
                          <p>SWIFT/IBAN Reference:</p>
                        </v-col>
                        <v-col cols="6" md="5" lg="3">
                          <p class="dark">
                            {{
                              selectedCompany.billingProfile
                                .accountAccountWireNo
                            }}
                          </p>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="6" md="5" lg="3">
                          <p>Account name:</p>
                        </v-col>
                        <v-col cols="6" md="5" lg="3">
                          <p class="dark">
                            {{
                              selectedCompany.billingProfile.accountHolderName
                            }}
                          </p>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="6" md="5" lg="3">
                          <p>Payment currency:</p>
                        </v-col>
                        <v-col cols="6" md="5" lg="3">
                          <p class="dark">
                            {{ selectedCompany.billingProfile.accountCurrency }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-tab-item>

            <!-- COMPANY STRUCTURE -->
            <v-tab-item>
              <div class="d-flex flex-column mt-7">
                <table style="width: 95%">
                  <tr class="table-head">
                    <th class="text-left pl-2">Name</th>
                    <!-- <th class="text-left">Status</th> -->
                    <th class="text-left">Role</th>
                    <th class="text-left">Phone number</th>
                    <th class="text-left">Email</th>
                  </tr>
                  <tr
                    class="table-data"
                    v-for="employee in employees"
                    :key="employee.userId"
                  >
                    <td>
                      <p class="dark pl-2">
                        {{ employee.firstname }} {{ employee.lastname }}
                      </p>
                    </td>
                    <!-- <td>
                      <p class="px-2">todo</p>
                    </td> -->
                    <td>
                      <p class="dark">{{ role(employee.userRole) }}</p>
                    </td>
                    <td>
                      <p class="dark">{{ employee.mobile }}</p>
                    </td>
                    <td>
                      <p class="dark">{{ employee.email }}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </v-tab-item>

            <!-- ACTIVITY TAB -->
            <v-tab-item>
              <p>activity</p>
            </v-tab-item>

            <!-- HISTORY TAB -->
            <v-tab-item>
              <div class="d-flex flex-column">
                <p class="mt-10">October 15, 2019</p>
                <div class="d-flex align-center mt-5">
                  <img src="/img/logo.png" alt />
                  <div class="d-flex flex-column mr-12 ml-2">
                    <p class="bold">Hester Manning</p>
                    <p>Blocked account</p>
                  </div>
                  <p class="ml-12">16:31pm</p>
                </div>
                <div
                  class="mt-2"
                  style="
                    height: 35px;
                    width: 1px;
                    margin-left: 23.5px;
                    background-color: gray;
                  "
                ></div>
                <div class="d-flex align-center mt-3">
                  <img src="/img/logo.png" alt />
                  <div class="d-flex flex-column mr-12 ml-2">
                    <p class="bold">Hester Manning</p>
                    <p>Blocked account</p>
                  </div>
                  <p class="ml-12">16:31pm</p>
                </div>

                <p class="mt-10">October 15, 2019</p>
                <div class="d-flex align-center mt-5">
                  <img src="/img/logo.png" alt />
                  <div class="d-flex flex-column mr-12 ml-2">
                    <p class="bold">Hester Manning</p>
                    <p>Blocked account</p>
                  </div>
                  <p class="ml-12">16:31pm</p>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </div>
      </div>
    </div>

    <v-dialog v-model="rejectDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>Reject {{ selectedCompany.registeredName }}?</h1>
            <p class="text-center mt-4">
              Prevent thic company from using your services and accessing your
              network.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="rejectDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(255,0,0)"
              depressed
              rounded
              @click="reject"
              >Reject</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="approveDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>Approve {{ selectedCompany.registeredName }}?</h1>
            <p class="text-center mt-4">
              The company will be considered as valid member and will be able to
              use your services and access your network.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="approveDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(113,210,48)"
              depressed
              rounded
              @click="approve"
              >Approve</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="blockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>Block {{ selectedCompany.registeredName }}?</h1>
            <p class="text-center mt-4">
              Prevent the company from being able to receive any emergency or
              appointments requests.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="blockDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(255,0,0)"
              depressed
              rounded
              @click="block"
              >Block</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unblockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>Unblock {{ selectedCompany.registeredName }}?</h1>
            <p class="text-center mt-4">
              This company will be re-activated and able to use your services
              again (receive emergency requests, appointments etc).
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="unblockDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="text-capitalize white--text"
              color="rgb(113,210,48)"
              depressed
              rounded
              @click="unblock"
              >Unblock</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { convertDate } from "../../convertDate";
export default {
  created() {
    if (this.selectedCompany.BORevisedStatus !== "pending") {
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}admin/subUserProfileListByTACompanyId`,
          {
            params: {
              taCompanyId: this.selectedCompany.companyProfileId,
            },
          }
        )
        .then((res) => {
          this.employees = res.data;
          console.log(this.employees);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  data() {
    return {
      employees: null,
      rejectDialog: false,
      approveDialog: false,
      blockDialog: false,
      unblockDialog: false,

      active: 0,
    };
  },
  computed: {
    selectedCompany() {
      return this.$store.state.insurance.insurances.find(
        (company) => company.companyProfileId === this.$route.params.id
      );
    },
  },
  methods: {
    convertDateHere(date) {
      return convertDate(date);
    },
    role(role) {
      if (role === "ta_admin") return "Admin";
      if (role === "ta_operation") return "Operator";
      if (role === "ta_finance") return "Finance Manager";
    },
    convertDay(day) {
      if (day === "mon") return "Monday";
      if (day === "tue") return "Tuesday";
      if (day === "wed") return "Wednesday";
      if (day === "thu") return "Thursday";
      if (day === "fri") return "Friday";
      if (day === "sat") return "Saturday";
      if (day === "sun") return "Sunday";
    },
    convertHour(hour) {
      const myHour = hour;
      if (hour < 12) {
        return myHour.toString() + "am";
      } else {
        return myHour.toString() + "pm";
      }
    },
    reject() {
      const credentials = {
        companyProfileId: this.$route.params.id,
        BORevisedStatus: "rejected",
      };
      this.$store.dispatch("rejectInsurance", credentials).then(() => {
        this.rejectDialog = false;
      });
    },

    approve() {
      const credentials = {
        companyProfileId: this.$route.params.id,
        BORevisedStatus: "accepted",
      };
      this.$store.dispatch("approveInsurance", credentials).then(() => {
        this.approveDialog = false;
      });
    },
    block() {
      const credentials = {
        userId: this.selectedCompany.taAdminUserProfile.userId,
        isBlocked: true,
      };
      this.$store.dispatch("blockInsurance", credentials).then(() => {
        this.blockDialog = false;
      });
    },
    unblock() {
      const credentials = {
        userId: this.selectedCompany.taAdminUserProfile.userId,
        isBlocked: false,
      };
      this.$store.dispatch("unblockInsurance", credentials).then(() => {
        this.unblockDialog = false;
      });
    },
  },
};
</script>

<style scoped>
table {
  table-layout: inherit;
}
</style>